import { Outlet, useLocation } from 'react-router-dom';
import Content from '../../../components/content';

export function VisitTypesLayout() {
    const location = useLocation();
    const pathname = location.pathname;
    const inFormContext = pathname.includes('edit') || pathname.includes('create');

    return (
        <Content
            headerTitle={pathname.includes('edit') ? 'Edit Visit Type' : pathname.includes('create') ? 'New Visit Type' : 'Visit Types'}
            backNavLink={inFormContext ? '/settings/visit-types' : '/settings'}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
